import { render } from "./InfoUrlFrame.vue?vue&type=template&id=3a4a4e2d&scoped=true"
import script from "./InfoUrlFrame.vue?vue&type=script&lang=js"
export * from "./InfoUrlFrame.vue?vue&type=script&lang=js"

import "./InfoUrlFrame.vue?vue&type=style&index=0&id=3a4a4e2d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4a4e2d"]])

export default __exports__